import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MobilityMapItem } from '../../definitions/mobility-map-item';
import { MapItemComponent } from '@ui/shared/util-map';

import { DetailViewModule } from '@ui/shared/ui-detail-view';
import { statusCodes } from '../../definitions/status-codes';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-mobility-map-item-details',
    templateUrl: './mobility-map-item-details.component.html',
    styleUrls: ['./mobility-map-item-details.component.scss'],
    imports: [
        DetailViewModule,
    ],
})
export class MobilityMapItemDetailsComponent implements MapItemComponent<MobilityMapItem> {
    public mapItem = input<MobilityMapItem | undefined>();
    public statusCode = computed(() => statusCodes[this.mapItem()?.statusCode ?? ''] ?? '');
}
